import React from 'react'
import { useLeamData } from 'hooks/useLeamData'
import { useDateRanges } from 'hooks/useDateRanges'
import { useWorkdaySummary } from 'hooks/useWorkdaySummary'
import AgroSection from './AgroSection'
import DataSection from './DataSection'
import WorkersSection from './WorkersSection'

const Leam = () => {
  const { leamData } = useLeamData()
  const dates = useDateRanges()
  const { data: workdayData } = useWorkdaySummary()

  if (leamData.loading) {
    return (
      <div className='p-6 bg-gray-50 min-h-screen'>
        <div className='flex justify-center items-center h-64'>
          <div className='text-lg text-gray-600'>Loading LEAM summary...</div>
        </div>
      </div>
    )
  }

  if (leamData.error) {
    return (
      <div className='p-6 bg-gray-50 min-h-screen'>
        <div className='flex justify-center items-center h-64'>
          <div className='text-lg text-red-600'>{leamData.error}</div>
        </div>
      </div>
    )
  }

  return (
    <div className='p-3 bg-gray-50 min-h-screen'>
      <div className='flex justify-between items-start mb-2'>
        <div>
          <h1 className='text-xl font-semibold text-green-600'>LEAM Dashboard</h1>
        </div>
      </div>

      <hr className='border-t border-gray-300 mb-3' />

      <AgroSection data={leamData} dates={dates} />
      
      <DataSection 
        data={leamData} 
        dates={dates} 
        type="picking"
        title="Resumen picking"
        color="blue"
      />
      
      <DataSection 
        data={leamData} 
        dates={dates} 
        type="packing"
        title="Resumen packing"
        color="purple"
      />
      
      <WorkersSection 
        leamData={leamData} 
        workdayData={workdayData} 
        previousDate={dates.previousDate} 
      />
    </div>
  )
}

export default Leam
